import { useIntl } from "react-intl";
import { useChatStore } from "@/stores/chat-store";

export function MessagesLauncher() {
  const intl = useIntl();
  const listOpen = useChatStore((s) => s.listOpen);
  const toggleList = useChatStore((s) => s.toggleList);
  const conversations = useChatStore((s) => s.conversations);
  const totalUnread = [...conversations.values()].reduce((sum, c) => sum + c.unreadCount, 0);

  const label = intl.formatMessage({ id: "chat.openMessages", defaultMessage: "Messages" });
  const count = totalUnread > 99 ? "99+" : totalUnread;

  return (
    <button
      type="button"
      onClick={toggleList}
      aria-label={label}
      aria-pressed={listOpen}
      aria-haspopup="dialog"
      title={label}
      className={`relative inline-flex h-9 w-9 items-center justify-center rounded-full text-ink/70 transition hover:bg-ink/[0.06] hover:text-ink ${
        listOpen ? "bg-ink/[0.06] text-ink ring-1 ring-ink/15" : ""
      }`}
    >
      <svg
        className="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.5}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z"
        />
      </svg>
      {totalUnread > 0 ? (
        <span className="absolute -right-0.5 -top-0.5 inline-flex min-w-[18px] items-center justify-center rounded-full bg-accent px-1 text-[10px] font-medium leading-[18px] text-on-accent">
          {count}
        </span>
      ) : null}
    </button>
  );
}
